import React from 'react';
import { Box, Button, RawHtml } from '@sparknz/spark-pattern-library';

import { useProductDetails } from 'journey/productDetails/provider';
import { ProductDetailsActionTypes } from 'journey/productDetails/reducer/productDetails.reducer';
import {
  ActionLayerStatus,
  IfpEligibilityCheckSteps,
} from 'journey/productDetails/typings';
import { useAuthorableContents } from 'shared/providers/AuthorableContentsProvider';

const CONTENT_KEY = 'productDetails.planEligibility.ineligibleMessage';

const IneligiblePlanResult = () => {
  const { dispatch } = useProductDetails();
  const { getText } = useAuthorableContents();

  const content = getText(CONTENT_KEY);

  const handleReturnClick = () =>
    dispatch({
      type: ProductDetailsActionTypes.SetActionLayer,
      actionLayerStatus: ActionLayerStatus.ShowNewPlan,
      ifpEligibility: {
        activeStep: IfpEligibilityCheckSteps.PlanSelection,
      },
    });

  return (
    <Box pt="s5">
      <Box mb="s4">
        <RawHtml variant="bodySMedium" html={content} />
      </Box>

      <Button variant="primary" onClick={handleReturnClick} fullWidth>
        Return to plan select
      </Button>
    </Box>
  );
};

export default IneligiblePlanResult;
